module.exports = __webpack_public_path__ + "static/media/portfolio-img-5.b20b2cd9.png";